export class InHomeUtils {
    static getValueAsString(value) {
        if (value !== undefined && value !== null) {
            return value.toString();
        }
        return "";
    }

    static isNull(value) {
        if (value === undefined || value === null) {
            return true;
        }
        return false;
    }

    static getdeviceType() {
        let deviceType = 'desktop';
        let userAgent = window.navigator.userAgent.toLowerCase();
        if (userAgent && (userAgent.indexOf('android') !== -1 || userAgent.indexOf('iphone') !== -1)) {
            deviceType = "mobile";
        }
        return deviceType;
    }

    static isNotNull(value) {
        if(typeof value !== 'string' && value !== undefined && value !== null){
            return true;
        }
        else if (typeof value === 'string' && value !== undefined && value !== ''){
            return true;
        }
        return false;
    }

    static isNotEmpty(value) {
        if (value !== undefined && value !== null && value !== '') {
            return true;
        }
        return false;
    }

    static getIndexOf(value, srchString) {
        if (value !== undefined && value !== null) {
            if (value.toString().indexOf(srchString) > -1)
                return true;
            else
                return false;
        }
        else { return false; }
    }

    static isNotNullObjects(obj /*, level1, level2, ... levelN*/) {
        try {
            var args = Array.prototype.slice.call(arguments, 1);

            for (var i = 0; i < args.length; i++) {
                if (!obj || !obj.hasOwnProperty(args[i])) {
                    return false;
                }
                obj = obj[args[i]];
            }
            return true;
        }
        catch (e) { return false; }
    }

    static arrayIncludes(array, value) {
        if (array.includes) {
            return array.includes(value);
        }
        else {
            return array.indexOf(value) > -1 ? true : false;
        }
    }
}